import { computed, shallowRef } from 'vue';

// A page's dialogs share one "which one is open" state, so two can never be
// open at once. `model(name)` gives a v-model for <SomeDialog v-model="…">.
//   const dialogs = useDialogs();
//   dialogs.open('edit', row);   // opens 'edit' (closes any other)
//   <EditDialog v-model="editOpen" :item="dialogs.selected.value" />
export function useDialogs() {
  const current = shallowRef(null);
  const selected = shallowRef(null);

  function open(name, item = null) {
    selected.value = item;
    current.value = name;
  }

  function close() {
    current.value = null;
  }

  function model(name) {
    return computed({
      get: () => current.value === name,
      set: (value) => {
        if (!value && current.value === name) current.value = null;
      },
    });
  }

  return { current, selected, open, close, model };
}
